// extracted by mini-css-extract-plugin
export default {"arrow-button":"ArrowButton_arrow-button__tHDi8","icon-wrapper":"ArrowButton_icon-wrapper__dBWe4"};